import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const MouseSelection = ({mouseSelection}) => { 
    if (mouseSelection === undefined) {
        return [];
    }

    return (
        <rect
          className="mouse-selection"
          x={mouseSelection.x1} y={mouseSelection.y1}
          width={mouseSelection.x2 - mouseSelection.x1}
          height={Math.abs(mouseSelection.y2 - mouseSelection.y1)}
        />
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MouseSelection);
